import { useEffect, useState } from 'react';
import { fetchOrderFifoPreview, OrderFifoPreviewLine } from '../api/orderProductsApi';

export function useOrderFifoPreview(orderId: string, products: readonly unknown[], enabled: boolean, refreshKey?: unknown, saved = false) {
  const request = JSON.stringify(products);
  const [state, setState] = useState<{ orderId: string; request: string; refreshKey: unknown; saved: boolean; lines: OrderFifoPreviewLine[]; failed: boolean }>();
  useEffect(() => {
    if (!enabled) return;
    let active = true;
    const timer = setTimeout(() => {
      fetchOrderFifoPreview(orderId, JSON.parse(request), saved).then(
        lines => { if (active) setState({ orderId, request, refreshKey, saved, lines, failed: false }); },
        () => { if (active) setState({ orderId, request, refreshKey, saved, lines: [], failed: true }); },
      );
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [orderId, request, enabled, refreshKey, saved]);
  return {
    lines: enabled && (state?.orderId === orderId && state?.request === request && state?.refreshKey === refreshKey && state?.saved === saved) ? state.lines : [],
    failed: enabled && (state?.orderId === orderId && state?.request === request && state?.refreshKey === refreshKey && state?.saved === saved) && state.failed,
  };
}
